import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { useApi } from "../../context/api.js";
import MDBox from "../MDBox";
import MDTypography from "../MDTypography";

function GenericQuizCorrector({ activityEndpoint, milestoneId, activityId, from, children }) {
  const api = useApi();
  const [results, setResults] = useState(null);

  useEffect(() => {
    api.reviewActivity(activityEndpoint, { milestoneId, activityId, from }).then((results) => {
      setResults(results || {});
    });
  }, [milestoneId, activityId, from]);

  return (
    <>
      {!results && <CircularProgress color="info" size={48} />}
      {!!results && (
        <MDBox
          sx={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "flex-start" }}
        >
          <MDBox>
            Score :{" "}
            <span style={{ fontWeight: "bold" }}>
              {results.score} / {results.totalScore} (
              {Math.round((results.score * 100) / results.totalScore)}%)
            </span>
            .
          </MDBox>
          {results.validationMark && (
            <MDTypography
              variant="caption"
              component="div"
              sx={{ fontStyle: "italic", lineHeight: "1.5", mt: 0.25 }}
            >
              Un résultat de {results.validationMark}% ou plus était requis pour valider cette étape
              automatiquement.
            </MDTypography>
          )}
          {!!results.answers && (
            <MDBox sx={{ maxHeight: "45vh", overflow: "auto" }}>
              {results.answers.map((result, index) => children({ ...result, index }))}
            </MDBox>
          )}
        </MDBox>
      )}
    </>
  );
}

GenericQuizCorrector.propTypes = {
  activityEndpoint: PropTypes.string.isRequired,
  milestoneId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  activityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  from: PropTypes.string,
  children: PropTypes.func.isRequired,
};

export default GenericQuizCorrector;
